import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_column_item = _resolveComponent("column-item", true);
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_RenderDom = _resolveComponent("RenderDom");
  return $props.cols.groups && Array.isArray($props.cols.groups) ? (_openBlock(), _createBlock(_component_el_table_column, _normalizeProps(_mergeProps({
    key: 0
  }, $options.columnbindAttr($props.cols))), {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.cols.groups, (item, index) => {
      return _openBlock(), _createBlock(_component_column_item, {
        key: index,
        cols: item
      }, _createSlots({
        _: 2
      }, [item.scopedSlots && item.scopedSlots.customRender ? {
        name: item.scopedSlots.customRender,
        fn: _withCtx(({
          scope
        }) => [_renderSlot(_ctx.$slots, item.scopedSlots.customRender, {
          scope: scope
        })]),
        key: "0"
      } : undefined]), 1032, ["cols"]);
    }), 128))]),
    _: 3
  }, 16)) : $props.cols.scopedSlots && $props.cols.scopedSlots.customRender ? (_openBlock(), _createBlock(_component_el_table_column, _normalizeProps(_mergeProps({
    key: 1
  }, $options.columnbindAttr($props.cols))), {
    default: _withCtx(scope => [_renderSlot(_ctx.$slots, $props.cols.scopedSlots.customRender, {
      scope: scope
    })]),
    _: 3
  }, 16)) : $props.cols.render && typeof $props.cols.render === 'function' ? (_openBlock(), _createBlock(_component_el_table_column, _normalizeProps(_mergeProps({
    key: 2
  }, $options.columnbindAttr($props.cols))), {
    default: _withCtx(scope => [_createVNode(_component_RenderDom, {
      row: scope.row,
      index: scope.$index,
      datakey: $props.cols.key,
      render: $props.cols.render
    }, null, 8, ["row", "index", "datakey", "render"])]),
    _: 1
  }, 16)) : $props.cols.ellipsis && typeof $props.cols.ellipsis === 'boolean' ? (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
    key: 3,
    "show-overflow-tooltip": ""
  }, $options.columnbindAttr($props.cols)), null, 16)) : (_openBlock(), _createBlock(_component_el_table_column, _normalizeProps(_mergeProps({
    key: 4
  }, $options.columnbindAttr($props.cols))), null, 16));
}